import React from "react";
import PageBody from "Common/Custom/PageBody";
import AddItemBtn from "Common/Custom/AddItemBtn";
import { HeadingOne } from "Common/Custom/HeadingOne";
import EmployeePerformanceListTable from "./components/EmployeePerformanceListTable";

const EmployeePerformanceList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Employee Performance List</HeadingOne>
                    <AddItemBtn url="add-employee-performance" title="Add Performance" />
                </>
            }
        >
            <div className="col-12">
                <EmployeePerformanceListTable />
            </div>
        </PageBody>
    );
};

export default EmployeePerformanceList;
